import { GetServerSidePropsContext } from 'next'

import { internalAuthApi } from '../api'

export type GetVerifiedSignupEmailResult = {
  email: string | null
  response: Response
}

export async function getVerifiedSignupEmail(
  token: string,
  ctx?: GetServerSidePropsContext
): Promise<GetVerifiedSignupEmailResult | null> {
  const result = await internalAuthApi.verifySignupToken(token, ctx)
  if (!result) return null
  const { data, response } = result

  return { email: data?.email ?? null, response }
}
